import {
  Box,
  Button,
  Container,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  makeStyles,
} from "@material-ui/core";
import {
  GeneralModal,
  HeaderWithButtons,
  ImageUploadPreview,
  InfoBox,
  InfoLine,
} from "../components-molecules";
import { HttpRegularDelete, HttpRegularPut } from "../service";
import {
  getBannerDetailsSymbols,
  updateBannerDetails,
} from "../redux/actions/getBannerDetails";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";

import CssBaseline from "@material-ui/core/CssBaseline";
import { getCollectionsSymbols } from "../redux/actions/getCollections";
import { theme } from "../constants/theme";

export const BannerDetails = (props: any) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  let { id }: { id: string } = useParams();
  const [deeplinkCopied, setDeepLinkCopied] = useState(false);

  const [Title, setTitle] = useState("");
  const [SubTitle, setSubTitle] = useState("");
  const [Collection, setCollection] = useState<any>();
  const [Published, setPublished] = useState<boolean | null>();

  const [editModalOpen, setEditModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [editType, setEditType] = useState("");

  useEffect(() => {
    dispatch(getBannerDetailsSymbols(id));
    dispatch(getCollectionsSymbols());
  }, []); // eslint-disable-line

  const data = useSelector(
    (state: any) => state.BannerDetailsSymbolsReducer.data
  );

  const collectionsData = useSelector((state: any) => {
    const collectionsList = state.CollectionSymbolsReducer.data;
    let collArr: any = [];
    collectionsList.forEach((element: any) => {
      if (element[1]?.length > 0) {
        collArr = [...collArr, ...element[1]];
      }
    });
    return collArr;
  });

  const handleSubmit = () => {
    switch (editType) {
      case "Title":
        handleSubmitBasicInfo("Title");
        break;
      case "SubTitle":
        handleSubmitBasicInfo("SubTitle");
        break;
      case "Collection":
        handleSubmitBasicInfo("Collection");
        break;
      case "Published":
        dispatch(togglePublish());
        break;
      default: {
        setEditModalOpen(false);
      }
    }

    setEditModalOpen(false);
  };

  const handleSubmitBasicInfo = (infoType: string) => {
    const body = {
      Title: data?.Title,
      SubTitle: data?.SubTitle,
      CollectionId: data?.CollectionId,
      Published: data?.Published,
    };
    if (infoType === "Title") {
      body.Title = Title;
    } else if (infoType === "SubTitle") {
      body.SubTitle = SubTitle;
    } else if (infoType === "Collection") {
      body.CollectionId = Collection.Id;
    } else if (infoType === "Published") {
      body.Published = Published;
    } else {
    }
    const updateFormBody = new FormData();
    updateFormBody.append("json", JSON.stringify(body));
    dispatch(
      updateBannerDetails(id, updateFormBody, null, () => {
        setTitle("");
        setSubTitle("");
        setCollection(null);
        setPublished(null);
      })
    );

    // return (dispatch: any) => {
    //   HttpRegularPut("/upc/", body, {
    //     dispatch,
    //     actionSuccess: getBannerDetailsSymbols,
    //     callback: ()=>{
    //       setTitle("");
    //       setSubTitle("");
    //       setCollection(null);
    //       setPublished(null);
    //     }
    //     // actionFailure: () => setError("Could not update!"),
    //   });
    // };
  };

  const handleRemove = () => {
    return (dispatch: any) =>
      HttpRegularDelete("/upc/banner/" + id, {
        dispatch: dispatch,
        actionSuccess: () => getBannerDetailsSymbols(id),
        callback: () => {
          history.push("/admin/collections");
        },
        // actionFailure: () => setError("Could not update!"),
      });
  };

  const handleSubmitImage = (file: any) => {
    const body = new FormData();
    body.append("file", file);
    const oldData = { ...data };
    if (oldData?.ImageUrl) {
      delete oldData.ImageUrl;
    }

    body.append("json", JSON.stringify({ ...oldData, ImageChanged: true }));
    return (dispatch: any) =>
      HttpRegularPut("/upc/banner/" + id, body, {
        dispatch: dispatch,
        actionSuccess: () => getBannerDetailsSymbols(id),
        // actionFailure: () => setError("Could not update!"),
      });
  };

  const togglePublish = () => {
    return (dispatch: any) =>
      HttpRegularPut(`/upc/banner/${id}/toggle-publish`, null, {
        dispatch: dispatch,
        actionSuccess: () => getBannerDetailsSymbols(id),
        // actionFailure: () => setError("Could not update!"),
      });
  };

  return (
    <Box className={classes.container}>
      <CssBaseline />
      <Container className={classes.root}>
        <HeaderWithButtons
          handleBack={() => history.goBack()}
          title={data?.Title ?? "Banner"}
          smallText="Promotional Banner"
        >
          <HeaderWithButtons.ButtonArea>
            <Button
              variant="contained"
              color="primary"
              onClick={handleRemove}
              style={{ paddingLeft: props.loading ? "12px" : "16px" }}
            >
              Remove
            </Button>
          </HeaderWithButtons.ButtonArea>
        </HeaderWithButtons>
        {/** alse || shopDetailsLoading || data.length === 0 ? */}

        <>
          <Container className={classes.detailsContainer}>
            <InfoBox title="Basic Information">
              <Grid
                onClick={() => {}}
                container
                className={classes.infoTextContainer}
              >
                <Grid item xs={3}>
                  <Typography
                    display="inline"
                    variant="caption"
                    component="span"
                    color="textSecondary"
                  >
                    IMAGE
                  </Typography>
                </Grid>

                <Grid item xs={4}>
                  <Typography
                    variant="body2"
                    component="span"
                    color="textSecondary"
                  >
                    Image with ratio 16:9 and 1920px x 1080px resolution will
                    look best on all screen densities.
                  </Typography>
                </Grid>
                <Grid item container justifyContent="flex-end" xs={5}>
                  <ImageUploadPreview
                    onChange={(file: any) => {
                      dispatch(handleSubmitImage(file));
                    }}
                    iconAreaHeight={15}
                    containerHeight={120}
                    previewImageUrl={data?.ImageUrl}
                    containerWidth={200}
                    iconHeight="15"
                    iconWidth="15"
                  />
                </Grid>
              </Grid>

              {/* End of Custom Grid */}

              <InfoLine
                name="TITLE"
                smallText={`${data?.Title ? data.Title.length + "/25" : ""}`}
                value={data?.Title ? data.Title : "Please set…"}
                onClick={() => {
                  setEditType("Title");
                  setTitle(data?.Title ?? "");
                  setModalTitle("Category Name");
                  setEditModalOpen(true);
                }}
              >
                <InfoLine.ArrowArea></InfoLine.ArrowArea>
              </InfoLine>
              <InfoLine
                name="SUBTITLE"
                value={data?.SubTitle ? data.SubTitle : "Please set…"}
                smallText={`${
                  data?.SubTitle ? data.SubTitle.length + "/80" : ""
                }`}
                onClick={() => {
                  setModalTitle("Subtitle");
                  setSubTitle(data?.SubTitle ?? "");
                  setEditType("SubTitle");
                  setEditModalOpen(true);
                }}
              >
                <InfoLine.ArrowArea></InfoLine.ArrowArea>
              </InfoLine>
              <InfoLine
                name="COLLECTION"
                value={
                  data?.CollectionName ? data.CollectionName : "Please set…"
                }
                onClick={() => {
                  setModalTitle("Collection");
                  setCollection(
                    collectionsData.find((el: any) => el.Id === data.Id)
                  );
                  setEditType("Collection");
                  setEditModalOpen(true);
                }}
              >
                <InfoLine.ArrowArea></InfoLine.ArrowArea>
              </InfoLine>
              <InfoLine
                name="STATUS"
                value={data?.Published ? "Published" : "Unpublished"}
                smallText={
                  data?.Published
                    ? "Banner is visible to TradeKart customers."
                    : "Banner is unpublished."
                }
                onClick={() => {
                  setModalTitle("Published");
                  setPublished(data?.Published ?? "");
                  setEditType("Published");
                  setEditModalOpen(true);
                }}
              >
                <InfoLine.ArrowArea></InfoLine.ArrowArea>
              </InfoLine>
              <InfoLine
                name="ORDER"
                isLastRow
                value={data?.RankNo ? data.RankNo : 0}
                smallText="You can change the position of the banner on the main Promotional banner page."
                onClick={() => {}}
              ></InfoLine>
            </InfoBox>
            <InfoBox title="Deep Link">
              <div className={classes.uMb8}>
                <Typography
                  display="block"
                  variant="body2"
                  component="p"
                  color="textSecondary"
                >
                  This link can be used for sharing promotions in email
                  newsletters.
                </Typography>
              </div>
              <InfoLine
                name="DEEP LINK"
                isLastRow
                value={
                  data?.DeepLink
                    ? data.DeepLink
                    : `TradeKart://Promotions/${data?.Title ?? ""}`
                }
                onClick={() => {
                  navigator.clipboard.writeText(
                    data?.DeepLink ??
                      `TradeKart://Promotions/${data?.Title ?? ""}`
                  );
                  setDeepLinkCopied(true);
                  setTimeout(() => {
                    setDeepLinkCopied(false);
                  }, 1000);
                }}
              >
                <InfoLine.ArrowArea noTick>
                  <Button
                    id="basic-button"
                    aria-controls="basic-menu"
                    aria-haspopup="true"
                  >
                    {/* <img src={printIcon} className={classes.buttonIcon} alt="printIcon" /> */}
                    <Typography
                      variant="button"
                      component="span"
                      color="primary"
                      className={classes.printButtonText}
                    >
                      {deeplinkCopied ? "Copied" : "Copy"}
                    </Typography>
                  </Button>
                </InfoLine.ArrowArea>
              </InfoLine>
            </InfoBox>

            <InfoBox title="Banner preview">
              <Grid
                onClick={() => {}}
                container
                className={classes.infoTextContainer}
              >
                <Grid item xs={3}>
                  <Typography
                    display="inline"
                    variant="caption"
                    component="span"
                    color="textSecondary"
                  >
                    IMAGE
                  </Typography>
                </Grid>

                <Grid item xs={4}>
                  <Typography
                    variant="body2"
                    component="span"
                    color="textSecondary"
                  >
                    Image with ratio 16:9 and 1920px x 1080px resolution will
                    look best on all screen densities.
                  </Typography>
                </Grid>
                <Grid item container justifyContent="flex-end" xs={5}>
                  <img
                    alt="preview"
                    src={data && data?.ImageUrl}
                    width="200"
                    height="100"
                  />
                </Grid>
              </Grid>
            </InfoBox>

            <GeneralModal
              visible={editModalOpen}
              title={modalTitle}
              description=""
              onClose={setEditModalOpen}
            >
              <GeneralModal.ContentArea>
                {editType === "Title" ? (
                  <TextField
                    placeholder="Banner Title"
                    value={Title}
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    id="Title"
                    label="Title"
                    name="Title"
                    onChange={(e) => setTitle(e.target.value)}
                    autoFocus
                    InputProps={{
                      classes: {
                        root: classes.cssOutlinedInput,
                        focused: classes.cssFocused,
                        notchedOutline: classes.notchedOutline,
                      },
                    }}
                  />
                ) : editType === "SubTitle" ? (
                  <TextField
                    placeholder="Subtitle"
                    value={SubTitle}
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    id="SubTitle"
                    label="SubTitle"
                    name="SubTitle"
                    onChange={(e) => setSubTitle(e.target.value)}
                    autoFocus
                    InputProps={{
                      classes: {
                        root: classes.cssOutlinedInput,
                        focused: classes.cssFocused,
                        notchedOutline: classes.notchedOutline,
                      },
                    }}
                  />
                ) : editType === "Collection" ? (
                  <FormControl
                    variant="outlined"
                    className={classes.selectArea}
                  >
                    <InputLabel id="demo-simple-select-outlined-label">
                      Collection
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      value={Collection?.Id}
                      disabled={props?.Vertical ? true : false}
                      onChange={(event: any) => {
                        // Should select from collection list
                        setCollection(
                          collectionsData.find(
                            (i: any) => i.Id === event.target.value
                          )
                        );
                        //setSelectedVertical();
                      }}
                      label="Collection"
                    >
                      {/* CollectionList  */}
                      {collectionsData.map((v: any, index: number) => (
                        <MenuItem key={index} value={v.Id}>
                          {v.Name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                ) : editType === "Published" ? (
                  <FormControl
                    variant="outlined"
                    className={classes.selectArea}
                  >
                    <InputLabel id="demo-simple-select-outlined-label">
                      Status
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      value={Published + ""}
                      onChange={(event: any) => {
                        setPublished(event.target.value);
                      }}
                      label="Status"
                    >
                      {/* CollectionList  */}

                      <MenuItem disabled={data?.Published} value={"true"}>
                        Publish
                      </MenuItem>
                      <MenuItem disabled={!data?.Published} value={"false"}>
                        Unpublish
                      </MenuItem>
                    </Select>
                  </FormControl>
                ) : (
                  <></>
                )}
              </GeneralModal.ContentArea>
              <GeneralModal.ButtonArea>
                <Button
                  onClick={() => setEditModalOpen(false)}
                  className={classes.cancelButton}
                >
                  <Typography variant="button" component="p" color="primary">
                    Cancel
                  </Typography>
                </Button>
                <Button onClick={handleSubmit} className={classes.submitButton}>
                  <Typography variant="button" component="p" color="inherit">
                    Submit
                  </Typography>
                </Button>
              </GeneralModal.ButtonArea>
            </GeneralModal>
          </Container>
        </>
      </Container>
    </Box>
  );
};
const useStyles = makeStyles({
  container: {
    display: "flex",
    justifyContent: "center",
  },
  imageList: {
    display: "flex",
    flexDirection: "row",
    marginTop: 15,
    paddingLeft: 0,
  },
  images: {
    width: 200,
    height: 150,
    marginRight: 10,
  },
  submitButton: {
    width: "80px",
    height: "48px",
    borderRadius: "8px",
    padding: "6px 16px",
    backgroundColor: theme.palette.primary.main,
    color: "white",
  },
  cancelButton: {
    width: "80px",
    height: "48px",
    borderRadius: "8px",
    padding: "6px 16px",
    backgroundColor: theme.palette.primary.light,
    marginRight: "8px",
  },
  cssOutlinedInput: {
    display: "flex",
    "&$cssFocused $notchedOutline": {
      border: `1px solid ${theme.palette.primary.main}`,

    },
  },

  cssFocused: {},

  notchedOutline: {
    border: "1px solid rgba(0, 0, 0, 0.12)",
  },
  printButtonText: {
    textTransform: "none",
  },
  root: {
    maxWidth: "840px",
    paddingLeft: 0,
    paddingRight: 0,
  },
  detailsContainer: {
    marginTop: "24px",
    paddingLeft: 0,
    paddingRight: 0,
  },
  printableSection: {
    display: "none",
  },
  infoTextContainer: {
    alignItems: "center",
    paddingTop: 15,
    paddingBottom: 15,
    borderBottom: "1px solid rgba(0, 0, 0, 0.08)",
  },
  uMb8: {
    marginBottom: 8,
  },
  selectArea: { width: "100%", marginBottom: 15 },
});
